/* eslint-disable no-param-reassign */
import { REACT_APP_API_URL } from 'react-native-dotenv'

import axios from 'axios'

import camelCase from 'lodash/camelCase'
import get from 'lodash/get'
import isArray from 'lodash/isArray'
import isEmpty from 'lodash/isEmpty'
import isObject from 'lodash/isObject'
// import join from 'lodash/join'
import map from 'lodash/map'
import reduce from 'lodash/reduce'
// import split from 'lodash/split'
// import upperFirst from 'lodash/upperFirst'

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || REACT_APP_API_URL
})

export const transformData = (data, transformator) => {
  const doReduce = (obj) => {
    if (isArray(obj)) {
      return map(obj, (item) => (isObject(item) ? doReduce(item) : item))
    }
    return reduce(
      obj,
      (acc, item, key) => ({
        ...acc,
        [transformator(key)]: isObject(item) ? doReduce(item) : item
      }),
      {}
    )
  }
  return doReduce(data)
}

const serializeJsonToQueryString = (obj) => {
  const getPathsArr = (items = obj, relativePath = '') => map(items, (item, name) => {
    const key = `${ !isEmpty(relativePath) ? `${ relativePath }.` : '' }${ name }`
    if (!isArray(item) && isObject(item)) {
      return getPathsArr(item, key)
    }
    return {
      [key]: item
    }
  })

  const pathsArr = getPathsArr()

  const getPaths = (paths = pathsArr) => reduce(paths, (acc, path) => {
    if (isArray(path)) {
      return { ...acc, ...getPaths(path) }
    }
    return { ...acc, ...path }
  }, {})

  return getPaths()
}

window.setApiUrl = (url = process.env.REACT_APP_API_URL) => {
  api.defaults.baseURL = url
}

// aplica transformadores de parametros
api.interceptors.request.use(
  (config) => {
    const transformator = item => item
    // TODO: check if this will be necessary in the future
    // let response = snakeCase(item)
    // response = split(response, '_')
    // response = map(response, (subString, index) => {
    //   if (index === 0) return subString
    //   return upperFirst(subString)
    // })


    if (!isEmpty(config.data)) {
      config.data = transformData(config.data, transformator)
    }
    if (!isEmpty(config.params)) {
      const params = transformData(config.params, transformator)
      config.params = serializeJsonToQueryString(params)
    }
    return config
  },
  (error) => Promise.reject(error)
)

// aplica headers
api.interceptors.request.use(
  (config) => {
    config.headers = {
      'Content-Type': 'application/json',
      ...get(config, 'headers', {})
    }
    return config
  },
  (error) => Promise.reject(error)
)

// aplica transformadores de resposta
api.interceptors.response.use(
  (response) => {
    if (isObject(response.data)) {
      response.data = transformData(response.data, camelCase)
    }
    return response
  },
  (error) => Promise.reject(error)
)

export default api

